<template>
  <div class="leaf-container">
    <HvhHoverElement class="hvh-flex align-center" :class="{ hovered: (stateItem || {}).hovered }" :style="`padding-left: ${leafLeftPadding}px`" @input="$emit('hover', { item, hover: $event })" ref="hoverElement" v-if="!isRoot">
      <Arrow class="clickable mr-1" :class="{ opened: isOpened, 'no-show': !hasChildren }" @click="emitOpen" />
      <slot :item="item" />
    </HvhHoverElement>

    <template v-if="isOpened">
      <Leafs
        class="leafs"
        :items="item.children"
        :state="state"
        @open="$emit('open', $event)"
        @click="$emit('click', $event)"
        @hover="$emit('hover', $event)"
        @zoom-item="$emit('zoom-item', $event)"
        @mouseenter="$emit('mouseenter', $event)"
        @mousein="$emit('mousein', $event)"
        @mouseleave="$emit('mouseleave', $event)"
        v-if="item.item.children"
      >
        <template slot-scope="{ item }">
          <slot :item="item" />
        </template>
      </Leafs>
      <div :style="`padding-left: ${leafLeftPadding + 20}px`" v-else>
        <div class="vue-treeselect__tip vue-treeselect__error-tip inline-block" v-if="item.errorLoading">
          <div class="vue-treeselect__icon-container"><span class="vue-treeselect__icon-error" /></div>
          <span class="vue-treeselect__tip-text vue-treeselect__error-tip-text">Error occurred while loading the results<a title="Click to retry" class="vue-treeselect__retry" @click="$emit('open', { item, open: true })">Retry?</a></span>
        </div>
        <LoadingLeaf v-else />
      </div>
    </template>
  </div>
</template>

<script>
import Arrow from './Arrow.vue';
import Leafs from './Leafs';
import HvhHoverElement from '../hover/HvhHoverElement.vue';
import LoadingLeaf from './LoadingLeaf.vue';

export default {
  props: ['item', 'isRoot', 'state'],
  components: { Leafs, Arrow, HvhHoverElement, LoadingLeaf },
  methods: {
    emitOpen() {
      if (this.hasChildren) {
        this.$emit('open', { item: this.item, open: !this.isOpened });
      }
    },
  },
  computed: {
    hasChildren() {
      var { children } = this.item.item;
      return (children === null || children?.any());
    },
    isOpened() {
      return this.isRoot || (this.hasChildren && (this.stateItem || {}).opened);
    },
    stateItem() {
      return this.state[this.item.stateId];
    },
    leafLeftPadding() {
      return 20 * (this.item.getNodeLevel() - 1) + 5;
    },
    isZoomItem() {
      return (this.stateItem || {}).zoomItem;
    },
  },
  watch: {
    isZoomItem() {
      if (this.isZoomItem)
        this.$emit('zoom-item', this.$refs.hoverElement.$el);
    },
  },
}
</script>

<style lang="scss" scoped>
.hovered {
  background-color: #f5f5f5;
}
</style>